import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "./components/HeroCarousel";
import GenreEntry from "./components/GenreEntry";
import LatestSection from "./components/LatestSection";
import HotSection from "./components/HotSection";
import IntroBand from "./components/IntroBand";

export default function Home() {
  useSeo({
    title: "蜜桃成熟时在线观看 - 高清电影免费在线观看平台",
    description:
      "蜜桃成熟时在线观看网站为您提供最新高清电影资源，涵盖丰富电影类型，支持在线播放，满足您的观影需求。精彩电影，一站观看尽享视觉盛宴。",
    keywords:
      "蜜桃成熟时在线观看,蜜桃成熟时电影,在线观看电影,高清电影,在线电影平台,影视播放,电影资源",
  });

  return (
    <SiteLayout>
      <HeroCarousel />
      <GenreEntry />
      <LatestSection />
      <HotSection />
      <IntroBand />
    </SiteLayout>
  );
}